import { getBooleanEnvValue } from './env.utils'

/**
 * Master kill-switch for the ENTIRE SVD (Smart Variant Discovery) program. BOTH surfaces gate on it,
 * on top of the shared `ramp_svd-rollout-web` experiment:
 *  - the product-card flow (server `getServerSideBaseProps` → `svd.config` re-export → `shouldUseSvdCard`)
 *  - the PDP buy-box flow (`useIsSvdEnabled`)
 *
 * Env-driven via `NEXT_PUBLIC_ENABLE_SVD_FLOW_DISCOVERY` — **true in dev and pre-integ, false everywhere
 * else** (prod-safe default `false`). While off, both surfaces stay dark regardless of the experiment bucket
 * (card: server skips the eval; PDP: `useIsSvdEnabled` returns false before the Statsig call). Per-env
 * values live in `.helm/values-*.yaml` (+ `.env` / `.env.local` for local dev).
 *
 * Reads only `env.utils` ON PURPOSE, so it stays dependency-free / client-safe: it's imported by both
 * client (PDP hook, card render path) and server code and must never drag in the statsig registry.
 */
export const ENABLE_SVD_FLOW_DISCOVERY = getBooleanEnvValue(process.env.NEXT_PUBLIC_ENABLE_SVD_FLOW_DISCOVERY, false, {
  required: false,
})
